import { cn } from '@/lib/utils'

interface Props {
  connected: boolean
  // Rótulo quando conectado (ex.: "Conectado", "Ativo"). Default "Conectado".
  connectedLabel?: string
  // Rótulo quando não conectado. Default "Não conectado".
  disconnectedLabel?: string
  className?: string
}

/**
 * Chip de status de conexão no padrão do design system — mesma linguagem do
 * "● Ativa" da ficha e do "● Conectado" do card de integração. Fonte única para
 * as páginas de detalhe das integrações (Google/Meta/Notion/Slack/Microvix) não
 * divergirem: conectado = ponto + texto em tom de sucesso; não conectado =
 * neutro. Substitui os `Badge variant="success|info"` com "Ativo/Inativo".
 */
export function ConnectionStatusChip({
  connected,
  connectedLabel = 'Conectado',
  disconnectedLabel = 'Não conectado',
  className,
}: Props) {
  if (connected) {
    return (
      <span
        className={cn(
          'inline-flex shrink-0 items-center gap-1.5 rounded-full bg-success/12 px-2 py-0.5 text-[11px] font-medium text-success',
          className,
        )}
      >
        <span className="size-1.5 rounded-full bg-success" />
        {connectedLabel}
      </span>
    )
  }
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full bg-secondary px-2 py-0.5 text-[11px] font-medium text-muted-foreground',
        className,
      )}
    >
      {disconnectedLabel}
    </span>
  )
}
